/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OwnersControllerFindAllQueryResponse, OwnersControllerFindAllQueryParams, OwnersControllerFindAll401, OwnersControllerFindAll403 } from "../../models/ownersController/OwnersControllerFindAll";

function getOwnersControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/owners` as const }  
  return res
}

/**
 * @summary Get all owners
 * {@link /api/v1/owners}
 */
export async function ownersControllerFindAll(params?: OwnersControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<OwnersControllerFindAllQueryResponse, ResponseErrorConfig<OwnersControllerFindAll401 | OwnersControllerFindAll403>, unknown>({ method : "GET", url : getOwnersControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}